export default __webpack_public_path__ + "static/media/add-items.d1814fa1.svg";